import { render, staticRenderFns } from "./VImg.vue?vue&type=template&id=b855a48a&scoped=true&"
import script from "./VImg.vue?vue&type=script&lang=js&"
export * from "./VImg.vue?vue&type=script&lang=js&"
import style0 from "./VImg.vue?vue&type=style&index=0&id=b855a48a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b855a48a",
  null
  
)

export default component.exports